import { LinkedDocumentType } from './LinkedDocumentType';

export interface ILinkedDocumentDto {
    documentId: string;
    documentType: LinkedDocumentType;
    documentTypeName: string;
    documentNumber?: string;
    addedAt?: string;
    addedBy?: string;
    navigationAllowed?: boolean;
    metaData?: Record<string, unknown>;
    status?: string;
    documentDate?: string;
    creationDate?: string;
}

export class LinkedDocument implements ILinkedDocumentDto {
    public readonly documentId: string;
    public readonly documentType: LinkedDocumentType;
    public readonly documentTypeName: string;
    public readonly documentNumber?: string;
    public readonly addedAt?: string;
    public readonly addedBy?: string;
    public readonly navigationAllowed: boolean;
    public readonly metaData?: Record<string, unknown>;
    public readonly status?: string;
    public readonly documentDate?: string;
    public readonly creationDate?: string;

    constructor(dto: ILinkedDocumentDto) {
        this.documentId = dto.documentId;
        this.documentType = dto.documentType;
        this.documentTypeName = dto.documentTypeName;
        this.documentNumber = dto.documentNumber;
        this.addedAt = dto.addedAt;
        this.addedBy = dto.addedBy;
        this.navigationAllowed = dto.navigationAllowed ?? false;
        this.metaData = dto.metaData;
        this.status = dto.status;
        this.documentDate = dto.documentDate;
        this.creationDate = dto.creationDate;
    }
}
